const WA_NUMBER = '50687704499';

export const whatsappMessages = {
  GENERAL:              'Hola, me interesa información sobre el programa de inglés de American English. ¿Podrían ayudarme?',
  HERO_PRUEBA:          'Hola, quiero realizar mi prueba de ubicación en American English. ¿Cómo procedo?',
  HERO_WHATSAPP:        'Hola, vi su sitio web y estoy interesado en el programa de inglés. ¿Me pueden dar más información?',
  CALCULADORA:          'Hola, usé la calculadora de salario en su web y me interesa saber cómo el inglés puede mejorar mi ingreso. ¿Pueden ayudarme?',
  CONVENIO_GENERAL:     'Hola, me interesa información sobre los convenios institucionales de American English.',
  CONVENIO_BAC:         'Hola, soy colaborador del BAC Credomatic y me interesa el convenio con American English.',
  CONVENIO_CCSS:        'Hola, soy colaborador de la CCSS y me interesa el convenio con American English.',
  CONVENIO_INA:         'Hola, me interesa el convenio entre American English y el INA.',
  CONVENIO_SERVICIO_CIVIL: 'Hola, soy funcionario público y me interesa el convenio de American English con Servicio Civil.',
  CONVENIO_COOPENAE:    'Hola, soy asociado de COOPENAE y me interesa el convenio con American English.',
  BOLSA_EMPLEO:         'Hola, me interesa la bolsa de empleo y las oportunidades laborales que ofrece American English.',
  CERTIFICACIONES:      'Hola, me interesa obtener más información sobre las certificaciones internacionales de American English.',
  CONTACTO:             'Hola, completé el formulario de contacto y quisiera más información sobre el programa de inglés.',
  PROGRAMA:             'Hola, revisé el programa de inglés en su sitio web y tengo algunas preguntas. ¿Me pueden ayudar?',
  DESCUENTO:            'Hola, vi la oferta del 25% de descuento en su sitio web y me interesa aprovecharla.',
  EXIT_POPUP:           'Hola, vi la oferta de 25% de descuento y quiero más información antes de decidir.',
  CERTIFICACIONES_TOEIC:  'Hola, me interesa agendar mi certificación TOEIC. ¿Cuáles son los próximos horarios disponibles?',
  CERTIFICACIONES_OXFORD: 'Hola, me interesa agendar mi certificación Oxford. ¿Cuáles son los próximos horarios disponibles?',
  PLACEMENT_ORAL:         'Hola, completé la prueba de ubicación escrita y quiero agendar mi examen de ubicación oral.',
  AEFK_HERO:            'Hola, me interesa el programa American English for Kids para mi hijo/a.',
  AEFK_METODO:          'Hola, me gustaría conocer más sobre el método del programa AEFK.',
  AEFK_FINAL:          'Hola, quiero información completa sobre el programa American English for Kids.',
};

export const openWhatsApp = (key) => {
  const message = whatsappMessages[key] || whatsappMessages.GENERAL;
  const encoded = encodeURIComponent(message);
  window.open(`https://wa.me/${WA_NUMBER}?text=${encoded}`, '_blank');
};

/**
 * Construye el mensaje de WhatsApp para agendar el examen oral tras la
 * prueba de ubicación escrita, pre-llenando nombre y nivel obtenido.
 * @param {string} name   Nombre del estudiante (ya sanitizado)
 * @param {string} level  Etiqueta de nivel (ej. "Básico Alto")
 * @returns {string}      Mensaje listo para enviar
 */
export const buildPlacementOralMessage = (name = '', level = '') => {
  const nombre = name.trim();
  const saludo = nombre ? `Hola, soy ${nombre}.` : 'Hola.';
  const nivel = level ? ` Mi resultado fue nivel ${level}.` : '';
  return `${saludo} Completé la prueba de ubicación escrita en su sitio web.${nivel} Quiero agendar mi examen de ubicación oral.`;
};

/**
 * Abre WhatsApp con el mensaje de agendamiento de examen oral pre-llenado.
 * @param {string} name   Nombre del estudiante
 * @param {string} level  Nivel obtenido
 */
export const openPlacementOral = (name, level) => {
  const encoded = encodeURIComponent(buildPlacementOralMessage(name, level));
  window.open(`https://wa.me/${WA_NUMBER}?text=${encoded}`, '_blank');
};

/**
 * Construye el mensaje de WhatsApp para solicitar información tras la
 * prueba de ubicación escrita, incluyendo el puntaje y el nivel obtenido.
 * @param {number} score  Cantidad de respuestas correctas (0-20)
 * @param {string} level  Etiqueta de nivel (ej. "Básico Alto")
 * @returns {string}      Mensaje multilínea listo para enviar
 */
export const buildPlacementInfoMessage = (score, level) => (
  `Hola, acabo de completar la prueba de ubicación escrita.\n`
  + `Obtuve ${score}/20 correctas y mi nivel es ${level}.\n`
  + `Me gustaría recibir más información sobre mis opciones.`
);

/**
 * Construye la URL de WhatsApp con el mensaje de información pre-llenado.
 * @param {number} score  Cantidad de respuestas correctas (0-20)
 * @param {string} level  Etiqueta de nivel obtenido
 * @returns {string}      URL completa de wa.me con el texto codificado
 */
export const buildPlacementInfoUrl = (score, level) => (
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(buildPlacementInfoMessage(score, level))}`
);
